import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CreateSubscriptionSuccess } from '../../subscription/action-creators';
import { CREATE_SUBSCRIPTION_SUCCESS } from '../../subscription/actions';
import AppState from '../../state';
import { NoOp } from '../../ui/action-creators';
import { GetArtists } from '../../artist/action-creators';

export const subscriptionSuccessSetActiveEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateSubscriptionSuccess>(CREATE_SUBSCRIPTION_SUCCESS),
    filter((action) => action.subscriptionType === 'record-label'),
    withLatestFrom(state$),
    map(([_action, state]) => {
      if (state.recordLabels.active) {
        return new GetArtists();
      }
      return new NoOp();
    })
  );
